export default {
  meta: {
    title: '代理商详情'
  }
};
